import { useState } from 'react';
import { commentsData } from '@/mocks/home';

export default function SectionComments() {
  const [liked, setLiked] = useState<Record<number, boolean>>({});

  const toggleLike = (id: number) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg">
              <i className="ri-chat-smile-2-line text-accent-600 text-lg"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              瓜友热评
            </h2>
          </div>
          <span className="text-xs md:text-sm text-foreground-500">精选评论 · 实时更新</span>
        </div>

        <div className="grid gap-4 md:gap-5">
          {commentsData.map((comment, i) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-xl p-4 md:p-5 hover:bg-background-200/70 transition-colors"
            >
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden flex-shrink-0 bg-secondary-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'none';
                      const parent = target.parentElement;
                      if (parent) {
                        parent.innerHTML = `<div class="w-full h-full flex items-center justify-center"><i class="ri-user-line text-secondary-500 text-sm"></i></div>`;
                      }
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-sm font-semibold text-foreground-900">{comment.name}</span>
                    <span className={`text-xs px-2 py-0.5 rounded-full ${
                      i === 0
                        ? 'bg-primary-100 text-primary-700'
                        : i === 1
                          ? 'bg-accent-100 text-accent-700'
                          : 'bg-secondary-100 text-secondary-700'
                    }`}>
                      {comment.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{comment.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    {comment.content}
                  </p>
                  <button
                    onClick={() => toggleLike(comment.id)}
                    className="flex items-center gap-1.5 text-xs cursor-pointer transition-colors"
                    style={{
                      color: liked[comment.id] ? 'oklch(var(--primary-500))' : 'oklch(var(--foreground-500))',
                    }}
                  >
                    <i className={`${liked[comment.id] ? 'ri-thumb-up-fill' : 'ri-thumb-up-line'} text-sm`}></i>
                    <span>{liked[comment.id] ? comment.likes + 1 : comment.likes}</span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}